import type { JSX } from 'react';

import { Breadcrumbs } from '@change/ds-core-ui/next';

import { CmsHtml } from 'src/app/shared/components/cms';

import { usePageBody } from './hooks/usePageBody';

export function PageBody(): JSX.Element {
	const {
		data: { html, styles, breadcrumbItems },
	} = usePageBody();

	return (
		<>
			<div
				// eslint-disable-next-line internal-rules/no-restricted-design-system-props
				sx={{
					'.business-model-icon': {
						width: [70, 94],
					},
				}}
			>
				<CmsHtml html={html} styles={styles} />
			</div>
			<div className="container">
				<Breadcrumbs items={breadcrumbItems} maxVisible={2} maxVisibleTablet={1} />
			</div>
		</>
	);
}
